import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/jacket.constants';

export * from './customer/default/jacket.constants';

export const templates = {
  Jacket: 'Jacket',
};

const RATIO = 4 / 3;

const { sizes, imageOptions } = getElementSize(ITEMS_BY_BREAKPOINTS, RATIO, templates.Jacket);
export { sizes, imageOptions };
